import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Fetches the live Google Places payload once; null while loading / on failure.
export const useGoogleReviews = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${API}/api/reviews`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (active) setData(d); })
      .catch(() => { if (active) setData(null); });
    return () => { active = false; };
  }, []);

  return data;
};
